<div class="flex items-center justify-between gap-3 w-full">
  <div class="flex-1">
    <p class="text-sm font-medium text-text-900">{{ procedureName() }}</p>
    <p class="text-xs text-text-500 mt-1">{{ procedureDescription() }}</p>
    <div class="flex items-center gap-2 mt-2">
      <span
        class="px-2 py-1 text-xs font-medium rounded text-text-50 bg-background-700"
      >
        Código: {{ procedureCode() }}
      </span>
    </div>
  </div>
  <div class="text-right shrink-0">
    <p class="text-sm font-bold text-text-900">R$ {{ procedurePrice() }}</p>
  </div>
</div>
